/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_How_We_WorkInputs */

const en_nav_how_we_work = /** @type {(inputs: Nav_How_We_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we work`)
};

const lv_nav_how_we_work = /** @type {(inputs: Nav_How_We_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs strādājam`)
};

/**
* | output |
* | --- |
* | "How we work" |
*
* @param {Nav_How_We_WorkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_how_we_work = /** @type {((inputs?: Nav_How_We_WorkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_How_We_WorkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_how_we_work(inputs)
	return en_nav_how_we_work(inputs)
});